// extracted by mini-css-extract-plugin
export default {"icon":"AnimationIcon_icon","off":"AnimationIcon_off"};